import * as React from "react";
import {connect} from "react-redux";
import {parseUploadedFiles} from "../actions/literatureWizardActions";
import ImportComponent from "../components/ImportComponent/ImportComponent";

export interface IImportProps {
    dispatchParseUploadedFiles: (files: FileList, history: any) => any,
    history: any
}

class ImportContainer extends React.PureComponent<IImportProps> {
    public render() {
        return (
            <ImportComponent {...this.props}/>
        );
    }
}

const mapDispatchToProps = {
    dispatchParseUploadedFiles: parseUploadedFiles
};

export default connect(null, mapDispatchToProps)(ImportContainer);



// WEBPACK FOOTER //
// ./src/containers/ImportContainer.tsx